import throttle from 'lodash/throttle';
import getRemBase from 'propel/getRemBase';

const cardParagraphs = document.querySelectorAll(
	'.navigation-featured-link-card__content p'
);

const setCardParagraphOffset = () => {
	cardParagraphs.forEach((cardParagraph) => {
		cardParagraph.parentElement.parentElement.style.setProperty(
			'--paragraphHeight',
			`${cardParagraph.offsetHeight / getRemBase()}rem`
		);
	});
};

window.addEventListener('resize', throttle(setCardParagraphOffset, 100));
window.addEventListener('navigation-opened', setCardParagraphOffset);
window.addEventListener('navigation-submenu-opened', setCardParagraphOffset);
